"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Transformation_1 = require("../Transformation");

var RecursiveExpressionEvaluator_1 = require("./RecursiveExpressionEvaluator");

var SyncEvaluator =
/*#__PURE__*/
function () {
  function SyncEvaluator(algExpr) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SyncEvaluator);

    this.algExpr = algExpr;
    this.config = config;
    this.expr = Transformation_1.transformAlgebra(algExpr);
    var context = {
      now: config.now || new Date(Date.now()),
      baseIRI: config.baseIRI || undefined,
      exists: config.exists,
      aggregate: config.aggregate
    };
    this.evaluator = new RecursiveExpressionEvaluator_1.SyncRecursiveEvaluator(context);
  }

  _createClass(SyncEvaluator, [{
    key: "evaluate",
    value: function evaluate(mapping) {
      var result = this.evaluator.evaluate(this.expr, mapping);
      return log(result).toRDF();
    }
  }, {
    key: "evaluateAsEBV",
    value: function evaluateAsEBV(mapping) {
      var result = this.evaluator.evaluate(this.expr, mapping);
      return log(result).coerceEBV();
    }
  }, {
    key: "evaluateAsInternal",
    value: function evaluateAsInternal(mapping) {
      var result = this.evaluator.evaluate(this.expr, mapping);
      return log(result);
    }
  }]);

  return SyncEvaluator;
}();

exports.SyncEvaluator = SyncEvaluator;

function log(val) {
  // console.log(val);
  return val;
}